<section class="text-and-blocks container" [ngClass]="variantClass">
  <div class="col-span-12">
    <h2 class="text-and-blocks__title" *ngIf="section.title">
      {{ section.title }}
    </h2>

    <div
      class="text-and-blocks__text"
      [innerHtml]="section.content | safeHtml"
      *ngIf="section.content"
    ></div>

    <div
      class="text-and-blocks__container"
      *ngIf="section.blocks?.length"
      [ngClass]="blockContainerClass"
    >
      <app-cms-text-and-blocks-block
        *ngFor="let block of section.blocks"
        [block]="block"
        [variant]="section.block_variant"
        [imageFormatVariant]="imageFormatVariant"
      ></app-cms-text-and-blocks-block>
    </div>
  </div>
</section>
